<template>
  <div class="main-content">
    <div class="main-wrap" style="padding: 20px 40px; font-size: 14px;">
      <div style="line-height: 30px;">
        <el-row>
          <router-link v-if="resumeId" :to="'/TalentDetail?id='+resumeId+'&type=1'" target="_blank">
            <el-col :span="2">
              <user-avatar :src="headImage" class="useravatar-cicle-m"></user-avatar>
            </el-col>
            <el-col :span="9">
              <div>{{meName}}</div>
              <div>
                <span v-if="degree">{{degree}}<el-divider direction="vertical"></el-divider></span>
                {{workYear}} 年经验
              </div>
            </el-col>
          </router-link>
        </el-row>
        <el-row>
          <el-col :span="2">
            面试职位：
          </el-col>
          <el-col :span="22">{{postName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            面试结果：
          </el-col>
          <el-col :span="22">
            <span>第{{interviewRound}}轮</span>
            <span>{{interviewStateText}}</span>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 20px">
        <el-card class="box-card" v-for="(interview, index) in interviewList" :key="index">
          <div slot="header" class="clearfix">
            <span>第{{interview.interviewRound}}轮</span>
            <span style="float: right; padding: 3px 0">{{interview.interviewStateText}}</span>
          </div>
          <div class="box-item">
            <div><i class="el-icon-location-outline"></i>{{interview.interviewPlace}}</div>
            <div>{{$Shared.formatDateTime2(interview.interviewTime)}}</div>
            <div class="text-right" v-if="index === 0">
              <el-button v-if="interview.interviewState == 11" type="text" class="button"
                @click="onCancelInterview(interview)">取消面试</el-button>
              <el-button v-else-if="interview.interviewState == 12 || interview.interviewState == 41" type="text"
                class="button" @click="onSetResult(interview)">设置结果</el-button>
              <el-button v-else-if="interview.interviewState == 43" type="text" class="button"
                @click="onCreateInterview(interview)">生成复试</el-button>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <interview-result-dialog :visible="resultVisible" :interviewId="interviewId" @close="onResultClose"
      @success="onResultSuccess" @interview="toCreateInterview"></interview-result-dialog>
    <interview-recreate-dialog :visible="createVisible" :interviewId="interviewId" @close="onCreateClose"
      @success="onCreateSuccess"></interview-recreate-dialog>
    <interview-cancel-dialog :visible="cancelVisible" :interviewId="interviewId" @close="onCancelClose"
      @success="onCancelSuccess"></interview-cancel-dialog>
  </div>
</template>

<script>
  import userAvatar from '~/components/UserAvatar';
  import interviewResultDialog from '~/components/InterviewResultDialog';
  import interviewRecreateDialog from '~/components/InterviewRecreateDialog';
  import interviewCancelDialog from '~/components/InterviewCancelDialog';
  import {
    basicInfoByNo,
    roundList
  } from '~/api/interview'
  export default {
    components: {
      userAvatar,
      interviewResultDialog,
      interviewRecreateDialog,
      interviewCancelDialog
    },
    data() {
      return {
        interviewNo: parseInt(this.$route.query.id),
        interviewId: 0,
        resumeId: 0,
        meName: '',
        headImage: '',
        degree: '',
        workYear: 0,
        companyName: '',
        postName: '',
        interviewRound: 0,
        interviewStateText: '',
        interviewList: [],
        resultVisible: false,
        createVisible: false,
        cancelVisible: false
      };
    },
    created() {
      if (!this.interviewNo) {
        this.$message.error('未找到面试信息');
      }
      this.getInterviewInfo();
      this.getRoundList();
    },
    methods: {
      getInterviewInfo() {
        var params = {
          interviewNo: this.interviewNo
        };
        basicInfoByNo(params).then(r => {
          if (r.errcode === 0) {
            let data = r.data;
            if (data) {
              this.resumeId = data.meDataId;
              this.meName = data.meName;
              this.headImage = data.headImage;
              this.degree = data.degree;
              this.workYear = data.workYear;
              this.companyName = data.companyName;
              this.postName = data.postName;
              this.interviewRound = data.interviewRound;
              this.interviewStateText = data.interviewStateText;
            }
          }
        });
      },
      getRoundList() {
        var params = {
          interviewNo: this.interviewNo
        };
        roundList(params).then(r => {
          if (r.errcode === 0) {
            this.interviewList = r.data;
          }
        })
      },
      onSetResult(interview) {
        this.interviewId = interview.interviewId;
        this.resultVisible = true;
      },
      onResultClose() {
        this.resultVisible = false;
      },
      onResultSuccess() {
        this.getInterviewInfo();
        this.getRoundList();
        this.resultVisible = false;
      },
      onCreateInterview(interview) {
        this.interviewId = interview.interviewId;
        this.createVisible = true;
      },
      onCreateClose() {
        this.createVisible = false;
      },
      onCreateSuccess(interviewId) {
        this.getInterviewInfo();
        this.getRoundList();
        this.createVisible = false;
      },
      toCreateInterview(interviewId) {
        this.interviewId = interviewId;
        this.resultVisible = false;
        this.createVisible = true;
      },
      onCancelInterview(interview) {
        this.interviewId = interview.interviewId;
        this.cancelVisible = true;
      },
      onCancelClose() {
        this.cancelVisible = false;
      },
      onCancelSuccess() {
        this.getInterviewInfo();
        this.getRoundList();
        this.cancelVisible = false;
      }
    }
  };
</script>

<style scoped>
  .box-card {
    margin-bottom: 20px;
    width: 500px;
  }

  .box-item {
    line-height: 30px;
  }
</style>